import React from 'react';

import IMG_CARD from 'assets/tags/Client-Card-Jen.svg';
import IMG_BACKGROUND from 'assets/tags/header-background.svg';
import IMG_SPARKLE from 'assets/tags/sparkle-light.png';
import IMG_MAP from 'assets/tags/Tag-Image-No-show-risk.svg';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ClientTagsSplashTopPanel.module.scss';

const ClientTagsSplashTopPanel = () => {
  const { t } = useTranslation();

  return (
    <section data-bem="ClientTagsSplashTopPanel" className={CN.topContainer}>
      <div data-bem="ClientTagsSplashTopPanel__column" className={CN.column}>
        <div data-bem="ClientTagsSplashTopPanel__col" className={CN.col}>
          <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
            <span className={CN.emoji} role="img" aria-labelledby="megaphone">
              {S.megaphone}
            </span>
            {S.space}
            {t('clientTags.splashPage.newFeature')}
          </div>
          <h3 data-bem="ClientTagsSplashTopPanel__title" className={CN.title}>
            {t('clientTags.splashPage.title')}
          </h3>
          <h5 className={CN.subTitle}>
            {t('clientTags.splashPage.subtitle.part1')}
            {S.space}
            <span className={CN.emojiHeart} role="img" aria-labelledby="Heart">
              {S.heartSlick}
            </span>
            {S.space}
            {t('clientTags.splashPage.subtitle.part2')}
          </h5>
          <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
            <span className={CN.emoji} role="img" aria-labelledby="Star">
              {S.star}
            </span>
            {S.space}
            {t('clientTags.splashPage.bullet1')}
          </div>
          <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
            <span className={CN.emoji} role="img" aria-labelledby="Star">
              {S.star}
            </span>
            {S.space}
            {t('clientTags.splashPage.bullet2')}
          </div>
          <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
            <span className={CN.emoji} role="img" aria-labelledby="Star">
              {S.star}
            </span>
            {S.space}
            {t('clientTags.splashPage.bullet3')}
          </div>
          <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
            {t('clientTags.splashPage.note')}
          </div>
        </div>
        <div data-bem="ClientTagsSplashTopPanel__col" className={CN.col}>
          <img src={IMG_SPARKLE} className={CN.imgSparkle} alt="Sparkle" data-bem="ClientTagsSplashTopPanel__img-sparkle" />

          <div data-bem="ClientTagsSplashTopPanel__imgMap" className={CN.imgMap}>
            <img src={IMG_MAP} alt="Graphics map description" />
          </div>
          <div data-bem="ClientTagsSplashTopPanel__imgCard" className={CN.imgCard}>
            <img src={IMG_CARD} alt="Card description" />
          </div>
        </div>
      </div>
      <img src={IMG_BACKGROUND} alt="background" className={CN.imgBackground} />
    </section>
  );
};
export default ClientTagsSplashTopPanel;
